import type { FC, ReactNode } from 'react';
import { useContext, useMemo } from 'react';

import { Slot } from '../../slot/slot.tsx';
import type { Appearance } from '../theme.context.ts';
import { ThemeContext } from '../theme.context.ts';

export type ThemeProviderNestedProps = {
    appearance?: Appearance;
    children?: ReactNode;
};

export const ThemeProviderNested: FC<ThemeProviderNestedProps> = ({ appearance: appearanceProp, children }) => {
    const parent = useContext(ThemeContext);
    const appearance = appearanceProp ?? parent.appearance;
    const { setAppearance } = parent;

    const contextValue = useMemo(() => ({ appearance, isRoot: false, setAppearance }), [appearance, setAppearance]);

    return (
        <ThemeContext.Provider value={contextValue}>
            <Slot data-appearance={appearance}>{children}</Slot>
        </ThemeContext.Provider>
    );
};
